




















































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Members from "../../clubs/members.vue";
import Bulletins from "../../clubs/activity_bulletins.vue";
import Activities from "../../clubs/activity.vue";

@Component({
  components: {
    Members,
    Bulletins,
    Activities
  }
})
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  membersModalVisible = false;

  bulletinsModalVisible = false;

  activityModalVisible = false;

  dispatchType = "club/list";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "俱乐部名称", dataIndex: "club_name" },
    { title: "状态", scopedSlots: { customRender: "status" } },
    { title: "成员数", scopedSlots: { customRender: "usercount" } },
    { title: "大型活动数", scopedSlots: { customRender: "bulletincount" } },
    { title: "活动数", scopedSlots: { customRender: "activitycount" } },
    { title: "创建时间", dataIndex: "created_time" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData(
      {
        stadium_id: this.stadiumId
      },
      false
    );
  }

  showMembersModal(id: number) {
    this.editId = id;
    this.membersModalVisible = true;
  }

  hideMembersModal() {
    this.membersModalVisible = false;
  }

  showBulletinsModal(id: number) {
    this.editId = id;
    this.bulletinsModalVisible = true;
  }

  hideBulletinsModal() {
    this.bulletinsModalVisible = false;
  }

  showActivityModal(id: number) {
    this.editId = id;
    this.activityModalVisible = true;
  }

  hideActivityModal() {
    this.activityModalVisible = false;
  }
}
